export default class MainNav {
    constructor() {
        this.mainNav = null;
        this.burger = null;
        this.classList = {
            mainNavClass: 'js-main-nav',
            toggleClass: 'js-nav-toggle',
            itemClass: 'js-nav-item',
            burgerClass: 'js-nav-burger',
            openedClass: 'is-opened'
        }

        this.init();
    }

    init() {
        const { burgerClass, mainNavClass } = this.classList;

        this.mainNav = document.querySelector(`.${mainNavClass}`);
        this.burger = document.querySelector(`.${burgerClass}`);

        if (this.mainNav && this.burger) {
           this.initEvents();
        }
    }

    initEvents() {
        // window.addEventListener('click', this.handleToggleClick.bind(this));
        //
        // window.addEventListener('keydown', e => {
        //     if (e.key === 'Escape') {
        //         this.closeMenu();
        //     }
        // });

        this.burger.addEventListener('click', this.openBurgerMenu.bind(this));
    }

    handleToggleClick(e) {
        const { itemClass, openedClass, toggleClass } = this.classList;
        const targetEl = e.target;

        if (targetEl) {
            const targetBtn = targetEl.closest(`.${toggleClass}`);
            const isClickOutside = !targetEl.classList.contains(toggleClass);

            if (targetBtn) {
                const targetItem = targetBtn.closest(`.${itemClass}`);
                targetItem.classList.toggle(openedClass);
            } else if (isClickOutside) {
                this.closeMenu();
            }
        }
    }

    closeMenu() {
        const { openedClass} = this.classList;
        const openedMenus = document.querySelectorAll(`.${openedClass}`);
        openedMenus.forEach(item => item.classList.remove(openedClass));
    }

    openBurgerMenu() {
        this.mainNav.classList.toggle('is-mobile-opened');
    }
}
